// removed by extract-text-webpack-plugin
module.exports = {"page-loading":"index__page-loading___1FGb6","page-loading-hide":"index__page-loading-hide___36K7_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/PageLoading/index.less
// module id = 1919
// module chunks = 3